import { DropDownSelectOptionDefinition } from '@scu/core-ui/dist/types/components/scu-table/types';
import { Permission } from '../permissions/permissions-utils';

export const RolesPaths = ['/system/roles'];
export const PermissionsPaths = ['/system/permissions'];
export const ReportsPaths = ['/system/reports'];
export const NewsAdministrationPaths = ['/system/news-administration'];
export const TechicalParametersPaths = ['/system/technical-parameters'];
export const BusinessParametersPaths = ['/system/business-parameters'];
export const LoggingsPaths = ['/system/loggings'];
export const ManualCallsPaths = ['/system/manual-calls'];
export const SchedulerPaths = ['/system/job-scheduler'];
export const EdiErrorPath = '/system/edi-errors';
export const FileTransferErrorPath = '/system/file-transfer-errors';
export const DispoImportPath = '/system/dispo-import';

export const getPermissionDropdownOptions = (): DropDownSelectOptionDefinition[] => {
  return Object.values(Permission).map((entry) => ({
    value: entry.id.toString(),
    displayValue: entry.name,
    selectOptionValue: entry.name,
  }));
};

export enum TechnicalSettingValueTypes {
  INT_VALUE = '1',
  STRING_VALUE = '2',
  EMAIL_VALUE = '3',
  INT_LIST = '4',
  STRING_LIST = '5',
  EMAIL_LIST = '6',
  TIME_VALUE = '7',
  BOOL_VALUE = '8',
  TIME_STAMP = '9',
  STRING_GLN_MAP = '10',
}

// key: key, value: prg_setting_id (vgl. Tabelle prg_setting)
export enum TechnicalSettingKeyToId {
  SUPPLIER_TYPE_IDS = 1, // Liste der Suppliertypen für Lieferanten. Eingabe getrennt durch Komma.
  HAULER_TYPE_IDS = 3, // Liste der Spediteurtypen für Spediteure. Eingabe getrennt durch Komma.
  DO_AUTOCREATE_DISPO_TIME = 4, // Zeitpunkt, an dem die automatische Dispoerstellung durchgeführt wird. Format hh24:mm. Nach Änderung müssen die Erstellungszeitpunkt-Werte in Schema-Parameter/Grundeinstellungen zwecks Validierung in den Bearbeitungsmodus versetzt und bei Bedarf angepasst und auf Schemen übertragen werden.
  SENDER_EMAIL = 5, // E-Mail-Adresse, die als Absender für den E-Mailversand verwendet wird.
  EKS_RECIPIENT_EMAIL = 7, // Liste von E-Mailadressen, die als Empfänger für Fehler beim EKS Import verwendet werden. Eingabe getrennt durch Komma.
  RETURN_FILE_TEMPLATE_VERSION = 8, // Versionsnummer der Rückmeldedateien
  EXCEL_PWD = 9, // Passwort für die Exceldateien der Spediteure
  RETURN_REASONS = 10, // Liste von Gründen in der Rückmeldedatei. Eingabe getrennt durch Komma.
  RESTRICTION_PALLET_WEIGHT_HP_UPPER_LIMIT = 11, // Dieser Parameter wird bei der Ermittlung der Restriktionsverletzung Unzulässiges Palettengewicht verwendet und bildet die Obergrenze in der Prüflogik. Eingegebener Wert ist in Kilogramm bspw. 100.
  RESTRICTION_PALLET_WEIGHT_GP_UPPER_LIMIT = 12, // Dieser Parameter wird bei der Ermittlung der Restriktionsverletzung Unzulässiges Palettengewicht verwendet und bildet die Obergrenze in der Prüflogik. Eingegebener Wert ist in Kilogramm bspw. 100.
  SENDER_ADDRESS_SUPPLIER_ORDER = 13, // PLZ und Stadt für Absender der Lieferantenbestellung
  SENDER_TELEPHONE_SUPPLIER_ORDER = 14, // Telefonnummer welche in der Kopfzeile der Lieferantenbestellung abgedruckt ist
  SENDER_CONTACT_SUPPLIER_ORDER = 15, // Kontaktadresse, welche in der Kopfzeile der Lieferantenbestellung abgedruckt ist. Kann E-Mail-Adresse, Faxnummer oder URL sein.
  SENDER_HEADER_TEXT_SUPPLIER_ORDER = 16, // Text, welcher in der Kopfzeile der Lieferantenbestellung verwendet wird. Mit (LAND) als Platzhalter für das Land der Dispo
  SENDER_HEADER_TEXT_LEXI_SUPPLIER_ORDER = 17, // Text, welcher in der Kopfzeile der Lieferantenbestellung verwendet wird, sobald Parameter "GLN von LEXI verwenden" aktiv ist. Mit (LAND) als Platzhalter für das Land der Dispo
  LOG_LEVEL = 18, // Logginglevel (Minimum ist ERROR, Steigerungen sind INFO und DEBUG)
  LOG_PURGE_INTERVAL = 19, // Intervall, nach dem alte Loggingeinträge gelöscht werden (in Tagen)
  DO_PURGE_LOGGING_TIME = 20, // Zeitpunkt, an dem automatisch alte Logging-Einträge in prg_logging gelöscht werden. Format hh24:mm.
  KOLIBRI_DO_AUTOCREATE_TIMEINT_LIST = 24, // Zeitpunkt, an dem die automatische Kolibriüberstragung durchgeführt wird. Format hh24:mm
  AUTO_ORDER_TIME_FROM = 25, // Dieser Parameter regelt, wann täglich der Service für den automatischen Bestellversand startet. Format hh24:mm.
  AUTO_ORDER_TIME_UNTIL = 26, // Dieser Parameter regelt, wann täglich der Service für den automatischen Bestellversand endet. Format hh24:mm.
  AUTO_ORDER_INTERVAL = 27, // Dieser Parameter gibt den Rhythmus in Minuten an, zu welchem der Service Automatischer Bestellversand gestartet wird.
  RECIPIENT_EMAIL = 28, // Liste von E-Mailadressen, die als Empfänger verwendet werden. Eingabe getrennt durch Komma.
  NOTIFICATION_SESSION_INTERVAL = 29, // Dauer in Minuten, nachdem bei einer aktiven Sitzung im Versandmonitor die Aktualisierungsaufforderung erscheint
  AUTO_LOGOUT_DURATION = 30, // Dauer in Minuten, nach der ein User bei Inaktivität automatisch ausgeloggt wird
  NF_DISPOWEEK_RESPONSE_TIME = 33, // Uhrzeit, welche für Rückmeldungen von Land, Lieferant und für die manuelle Dispowochenerstellung verwendet wird. Format: hh24:mm
  EXTEND_DISPO_EDIT = 48, // zeigt an ob Dispos außerhalb Status CRE editiert werden dürfen
  LEXI_GLN_MAP = 49, // liefert die verfügbaren GLNs bei "Absender LExI"
}

export enum ReportTimeSpecificityValue {
  DAY_SPECIFIC = 'day-specific',
  WEEK_SPECIFIC = 'week-specific',
}

export enum ReportType {
  REIMBURSEMENT_DL = 'remibursement-dl',
}

// key: ReportType, value: report type id
export const reportTypeIdMap = new Map<ReportType, number>([[ReportType.REIMBURSEMENT_DL, 1]]);
